<app-modal-notification #confirmation (mainActionClicked)="modalSubmitted($event)"></app-modal-notification>

<div class="card" style="margin-bottom: 15px;">
  <div class="card-body">
    <div class="row">
      <div class="col-md-auto d-flex flex-column justify-content-center">
        <img alt="profile-image" height="140" width="140" [src]="practitioner.profileImage">
      </div>
      <div class="col-md-auto flex-fill">
        <div class="flex-fill practitioner-name"><a [routerLink]="['/practitioner', practitioner.id]">{{ practitioner.firstName + ' ' + practitioner.lastName }}</a></div>
        <div class="specialty-text">
          <span *ngFor="let specialty of practitioner.specialties; let i = index">
            {{ specialty.name }}<span *ngIf="i !== practitioner.specialties.length - 1">,</span>
          </span>
        </div>
        <div class="address-text">
          {{ practitioner.location?.getFullAddress() }}
        </div>
        <div class="d-flex flex-wrap mt-4 practitioner-details align-items-center" *ngIf="!isMobileScreen">
          <div class="practitioner-cost">
            <ng-container i18n="search result|Shows what the starting cost of the service is.@@labelStartingCost">
              Starting at</ng-container> £{{ practitioner.getStartingCost() }}
          </div>
          <div>
            <span>
              <ng-container i18n="insurance options|The allowed insurance options to be displayed for dropdowns.@@labelInsuranceOptions">
                { practitioner.getInsurance(), select, All {All} Private {Private} Public {Public}}
              </ng-container>
              <ng-container i18n="label|The type of insurance a practitioner offers.@@labelInsurance">Insurance</ng-container>
            </span>
          </div>
          <div>{{ practitioner.getLanguages() }}</div>
        </div>
      </div>
    </div>
    <div *ngIf="isMobileScreen">
      <div class="d-flex flex-wrap align-items-end practitioner-details" style="margin-top: 17px;">
        <div>
          <span style="vertical-align: middle;"><b><ng-container i18n="search result|Shows what the starting cost of the service is.@@labelStartingCost">
            Starting at</ng-container> £{{ practitioner.getStartingCost() }}</b>
          </span>
        </div>
        <div>
          <span style="vertical-align: middle;">
            <ng-container i18n="insurance options|The allowed insurance options to be displayed for dropdowns.@@labelInsuranceOptions">
              { practitioner.getInsurance(), select, All {All} Private {Private} Public {Public}}
            </ng-container>
            <ng-container i18n="label|The type of insurance a practitioner offers.@@labelInsurance">Insurance</ng-container>
          </span>
        </div>
        <div>
          <span style="vertical-align: middle;">{{ practitioner.getLanguages() }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="card-actions d-flex flex-column align-items-center">
    <div class="dropdown">
      <button  class="btn btn-primary search-button mt-2 dropdown-toggle" type="button" id="actionsMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        Actions
      </button>
      <div class="dropdown-menu" aria-labelledby="actionsMenuButton">
        <a class="dropdown-item" [routerLink]="['/practitioner', practitioner.id]" i18n="button|Allows a user to share a practitioner's profile link.@@linkSharePractitioner">View profile</a>
        <a *ngIf="actions.canApprove" class="dropdown-item" style="cursor: pointer;" (click)="openModal(statusReference.Approved, practitioner.id)">Approve</a>
        <a *ngIf="actions.canConditionallyApprove" class="dropdown-item" style="cursor: pointer;" (click)="openModal(statusReference.ApprovedConditionally, practitioner.id)">Approve with Conditions</a>
        <a *ngIf="actions.canReject" class="dropdown-item" style="cursor: pointer;" (click)="openModal(statusReference.Rejected, practitioner.id)">Reject</a>
      </div>
    </div>
  </div>
</div>
